/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AgreementTypeFromJSON, AgreementTypeToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, CarFromJSON, CarToJSON, CarModelDictionaryValueFromJSON, CarModelDictionaryValueToJSON, CustomerFromJSON, CustomerToJSON, ReservationFromJSON, ReservationToJSON, } from './';
export function AgreementFromJSON(json) {
    return AgreementFromJSONTyped(json, false);
}
export function AgreementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'agreementNumber': json['agreementNumber'],
        'customer': !exists(json, 'customer') ? undefined : CustomerFromJSON(json['customer']),
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'signedByCustomer': json['signedByCustomer'],
        'begins': (new Date(json['begins'])),
        'ends': (new Date(json['ends'])),
        'type': !exists(json, 'type') ? undefined : AgreementTypeFromJSON(json['type']),
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'carModels': !exists(json, 'carModels') ? undefined : (json['carModels'] === null ? null : json['carModels'].map(CarModelDictionaryValueFromJSON)),
        'reservations': !exists(json, 'reservations') ? undefined : (json['reservations'] === null ? null : json['reservations'].map(ReservationFromJSON)),
    };
}
export function AgreementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'agreementNumber': value.agreementNumber,
        'customer': CustomerToJSON(value.customer),
        'customerId': value.customerId,
        'signedByCustomer': value.signedByCustomer,
        'begins': (value.begins.toISOString().substr(0, 10)),
        'ends': (value.ends.toISOString().substr(0, 10)),
        'type': AgreementTypeToJSON(value.type),
        'car': CarToJSON(value.car),
        'carId': value.carId,
        'carModels': value.carModels === undefined ? undefined : (value.carModels === null ? null : value.carModels.map(CarModelDictionaryValueToJSON)),
        'reservations': value.reservations === undefined ? undefined : (value.reservations === null ? null : value.reservations.map(ReservationToJSON)),
    };
}
